module.exports = __webpack_public_path__ + "img/img2.e0bce889.png";